export default __webpack_public_path__ + "static/media/np_search.fd84a7b4.svg";